module.exports = __webpack_public_path__ + "static/img/tupianbgc.2be1f865.png";